import { dew as _ListWorkbooksResponseDew } from "./ListWorkbooksResponse";
import { dew as _WorkbookResponseDew } from "./WorkbookResponse";
import { dew as _WorkbookDew } from "./Workbook";
import { dew as _CreateWorkbookConfigDew } from "./CreateWorkbookConfig";
import { dew as _WorkbookUpdateDew } from "./WorkbookUpdate";
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  var __createBinding = exports && exports.__createBinding || (Object.create ? function (o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = {
        enumerable: true,
        get: function () {
          return m[k];
        }
      };
    }
    Object.defineProperty(o, k2, desc);
  } : function (o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
  });
  var __exportStar = exports && exports.__exportStar || function (m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
  };
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  __exportStar(_ListWorkbooksResponseDew(), exports);
  __exportStar(_WorkbookResponseDew(), exports);
  __exportStar(_WorkbookDew(), exports);
  __exportStar(_CreateWorkbookConfigDew(), exports);
  __exportStar(_WorkbookUpdateDew(), exports);
  return exports;
}